import React from 'react'

import { AvatarImage, ReceivedLogoContainer } from './MessageLogo.style'

interface Props {
  avatarLogo: string
}

const MessageLogo: React.FC<Props> = ({ avatarLogo }) => {

  return (
    <ReceivedLogoContainer>
      <AvatarImage src={avatarLogo} />
    </ReceivedLogoContainer>
  )
}
export default MessageLogo
